import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { MethodSection } from './components/MethodSection';
import { AudienceSection } from './components/AudienceSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
import { initPixel, trackPageView } from './lib/pixel';
export function App() {
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen font-sans text-charcoal bg-cream selection:bg-gold/30 selection:text-charcoal-dark" data-id="element-0">
      <UrgencyBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <MethodSection data-id="element-5" />
        <AudienceSection data-id="element-6" />
        <OfferSection data-id="element-7" />
      </main>

      <Footer data-id="element-8" />
    </div>;
}